import { useQuery } from '@tanstack/react-query';
import { getResourceById } from 'services/api/requests/capacity/resource/resources';

export const useGetResourceWithId = (id: Number) => {
	return useQuery(['resourceWithId', id], getResourceById, {
		refetchOnWindowFocus: false,
	});
};
